export const Ripple = () => (
  <div className="ripple" aria-hidden="true" data-testid="ripple-animation">
    {[0, 1, 2, 3].map((i) => (
      <span key={i} className={`ripple-ring ${i % 2 ? "ring-orange" : "ring-black"}`} style={{ animationDelay: `${i * 1.25}s` }} />
    ))}
  </div>
);
